export interface AdminUserOrgRef {
  id: number;
  name: string;
  slug: string;
  role: string;
}

/** One row of GET /admin/users. There is no write endpoint for this, by
 *  design `superadmin` is only grantable via a shell command on the
 *  backend, so no UI here should imply it's toggleable. */
export class AdminUserRow {
  id!: number;
  email!: string;
  name!: string;
  confirmed!: boolean;
  superadmin!: boolean;
  ssoProviders: string[] = [];
  organizations: AdminUserOrgRef[] = [];
  createdAt!: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.email = data.email;
    this.name = data.name;
    this.confirmed = !!data.confirmed;
    this.superadmin = !!data.superadmin;
    this.ssoProviders = data.sso_providers ?? [];
    this.organizations = data.organizations ?? [];
    this.createdAt = data.created_at;
  }
}

/** `totals` on GET /admin/users, for the whole filtered list. */
export class AdminUserTotals {
  users!: number;
  confirmed!: number;
  superadmins!: number;
  sso!: number;

  constructor(data: any = {}) {
    this.users = data.users ?? 0;
    this.confirmed = data.confirmed ?? 0;
    this.superadmins = data.superadmins ?? 0;
    this.sso = data.sso ?? 0;
  }

  /** 0–1. */
  get confirmedShare(): number {
    return this.users > 0 ? this.confirmed / this.users : 0;
  }
}
